import { render, staticRenderFns } from "./unionList.vue?vue&type=template&id=44c7adae&scoped=true&"
import script from "./unionList.vue?vue&type=script&lang=js&"
export * from "./unionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7adae",
  null
  
)

export default component.exports